// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"mQ-z","upvoteIcon":"nQ-z","downvoteIcon":"oQ-z","feedbackIcon":"pQ-z"};